module.exports = __webpack_public_path__ + "img/landos-slide__bg.jpg?46fe586fdcd54517862e8ef8755ce1a2";